// EditFieldModal.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import env from "../../../../../config/env";
import localforage from "localforage";
import { useUserInfo } from "../../../../../context/user";


const EditFieldModal = ({
  isOpen,
  onClose,
  field,
  label,
  user,
  updateUser,
  userActiveLocation,
}) => {
  const BASE_URL = `${env.API_URL}/v1`;
  const [value, setValue] = useState("");
  const saveActiveLocation = useUserInfo()[5]

  useEffect(() => {
    if (user && field) {
      setValue(user[field] || userActiveLocation[field] || "");
    }
  }, [user, field, userActiveLocation]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (user[field]) {
        const updatedData = {
          _id: user._id,
          userName: field === "userName" ? value : user.userName,
          email: field === "email" ? value : user.email,
          contactNumber: user.contactNumber,
        };

        const response = await axios.put(
          `${BASE_URL}/user/chatuser/update`,
          updatedData
        );
        if (response?.data) {
          updateUser(response?.data?.data);
          onClose();
        }
      } else {
        const updateBusinessName = {
          _id: userActiveLocation.id,
          business_name: value,
        };

        const response = await axios.put(
          `${BASE_URL}/accounts`,
          updateBusinessName
        );
        if (response?.data) {
          saveActiveLocation({ ...userActiveLocation, business_name: value });
          onClose();
        }
      }
    } catch (error) {
      console.error("Error:", error);
      alert(`An error occurred while updating ${label.toLowerCase()}.`);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-full max-w-sm shadow-lg relative">
        <button
          className="absolute top-2 right-3 text-gray-500 hover:text-black text-xl"
          onClick={onClose}
        >
          &times;
        </button>
        <h2 className="text-lg font-medium mb-4">Edit {label}</h2>
        <form onSubmit={handleSubmit}>
          <input
            type={field === "email" ? "email" : "text"}
            placeholder={`Enter ${label}`}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-4 py-2 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            className={`w-full py-2 rounded-md text-white font-medium ${
              value.trim()
                ? "bg-black hover:bg-black"
                : "bg-gray-200 text-gray-400 cursor-not-allowed"
            }`}
            disabled={!value.trim()}
          >
            Save Changes
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditFieldModal;
